import { useLanguage } from '../../i18n/LanguageContext';
import { experienceImages, siteContent } from '../../data/siteContent';
import { PageHero, Surface } from '../../components/SitePrimitives';

const Experiences = () => {
    const { language } = useLanguage();
    const page = siteContent[language].pages.experiences;

    return (
        <main className="bg-nude-50">
            <PageHero image={page.hero} title={page.title} subtitle={language === 'fr' ? 'Un parcours construit entre la recherche, la rééducation, la clinique et l’accompagnement international.' : language === 'en' ? 'A career shaped by research, rehabilitation, clinical practice and international care.' : 'Una trayectoria construida entre la investigación, la rehabilitación, la práctica clínica y el acompañamiento internacional.'} />
            <div className="mx-auto max-w-5xl px-5 py-16 sm:px-8 sm:py-24">
                <div className="space-y-5">
                    {page.items.map((item, index) => (
                        <Surface
                            key={item.key}
                            className={`grid items-center gap-7 p-6 sm:p-9 ${index % 2 === 1 ? 'lg:grid-cols-[1fr_10rem]' : 'lg:grid-cols-[10rem_1fr]'}`}
                        >
                            <div className={`flex items-center justify-center ${index % 2 === 1 ? 'lg:order-2' : ''}`}>
                                <img src={experienceImages[item.key]} alt="" className="max-h-28 max-w-36 object-contain" />
                            </div>
                            <div className={index % 2 === 1 ? 'lg:order-1' : ''}>
                                <div className="flex flex-wrap items-baseline justify-between gap-3">
                                    <h2 className="text-2xl font-medium tracking-tight text-brown-50">{item.title}</h2>
                                    <p className="section-eyebrow">{item.period}</p>
                                </div>
                                <p className="mt-4 text-base leading-8 text-stone-600">{item.body}</p>
                            </div>
                        </Surface>
                    ))}
                </div>
            </div>
        </main>
    );
};

export default Experiences;
